import i18n from 'i18next';

const addLangQuery = (url: string): string => {
  const lang = i18n.language;

  if (!lang) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}lang=${lang}`;
};

export default addLangQuery;
